import { render, staticRenderFns } from "./SpamDomains.vue?vue&type=template&id=758ba722&scoped=true"
import script from "./SpamDomains.vue?vue&type=script&lang=js"
export * from "./SpamDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758ba722",
  null
  
)

export default component.exports